import { groupArrayByKeys } from '@campus/utils';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NAME, selectAll, selectEntities, selectIds, selectTotal, State } from './purchase-product.reducer';

export const selectPurchaseProductState = createFeatureSelector<State>(NAME);

export const getError = createSelector(selectPurchaseProductState, (state: State) => state.error);

export const getLoaded = createSelector(selectPurchaseProductState, (state: State) => state.loaded);

export const getAll = createSelector(selectPurchaseProductState, selectAll);

export const getCount = createSelector(selectPurchaseProductState, selectTotal);

export const getIds = createSelector(selectPurchaseProductState, selectIds);

export const getAllEntities = createSelector(selectPurchaseProductState, selectEntities);

/**
 * returns array of objects in the order of the given ids
 * @example
 * purchaseProduct$: PurchaseProductInterface[] = this.store.pipe(
    select(PurchaseProductQueries.getByIds, { ids: [2, 1, 3] })
  );
 */
export const getByIds = createSelector(selectPurchaseProductState, (state: State, props: { ids: number[] }) => {
  return props.ids.map((id) => state.entities[id]);
});

/**
 * returns array of objects in the order of the given ids
 * @example
 * purchaseProduct$: PurchaseProductInterface = this.store.pipe(
    select(PurchaseProductQueries.getById, { id: 3 })
  );
 */
export const getById = createSelector(
  selectPurchaseProductState,
  (state: State, props: { id: number }) => state.entities[props.id]
);

export const getByProductId = createSelector(getAll, (purchaseProducts) =>
  groupArrayByKeys(purchaseProducts, ['productId'])
);

export const getByPurchaseId = createSelector(getAll, (purchaseProducts) =>
  groupArrayByKeys(purchaseProducts, ['purchaseId'])
);
